import { render, staticRenderFns } from "./StepperHeader.vue?vue&type=template&id=20a3dc25"
import script from "./StepperHeader.ts?vue&type=script&lang=ts&external"
export * from "./StepperHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports